<template>
  <v-container fluid class="pa-4">
    <!-- Header -->
    <v-row align="center" justify="center">
      <v-col cols="12" md="auto">
        <div class="d-flex align-center justify-center">
          <v-avatar color="primary" size="44" class="mr-3 elevation-2">
            <v-icon color="white">mdi-book-open-page-variant</v-icon>
          </v-avatar>
          <div>
            <h1 class="text-h5 font-weight-black grey--text text--darken-3 mb-0">Entradas de Diario</h1>
            <span class="text-caption grey--text">Gestión de asientos contables</span>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12">
        <search-header-po @dataFilters="searchLoaded($event)" />
      </v-col>
    </v-row>

    <v-row class="mt-1">
      <v-col cols="12">
        <v-card class="rounded-lg" elevation="2">
          <v-data-table v-if="loading == false" :headers="headersDataDiary" :items="dataDiary_filtered"
            sort-by="calories" class="elevation-0" dense
            :footer-props="{ 'items-per-page-options': [15, 30, 50, -1], 'items-per-page-text': 'Filas:' }">
            <template v-slot:top>
              <v-toolbar flat class="rounded-t-lg">
                <v-icon left color="primary">mdi-format-list-bulleted</v-icon>
                <v-toolbar-title class="text-subtitle-1 font-weight-bold">Entradas</v-toolbar-title>
                <v-chip small outlined color="primary" class="ml-3 font-weight-bold">{{ dataDiary_filtered.length
                  }}</v-chip>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" fullscreen transition="dialog-bottom-transition">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-if="$store.state.auth.globalFeatures.includes('CON-022')" @click="showDialogNew"
                      color="primary" v-bind="attrs" v-on="on" class="px-4 py-2 text-none rounded-lg elevation-2">
                      <v-icon left>mdi-plus</v-icon>
                      Nueva entrada de diarios
                    </v-btn>
                  </template>

                  <v-card class="elevation-0">
                    <v-app-bar flat dark color="primary" class="px-4">
                      <v-btn icon dark @click="closeDialog">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <v-toolbar-title class="text-h6 font-weight-medium ml-3 white--text">
                        {{ formTitle }}
                      </v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-autocomplete v-model="filters.business" :items="itemsBussines" label="Unidad de negocio"
                        outlined dense hide-details class="black--text"
                        prepend-inner-icon="mdi-office-building"></v-autocomplete>
                      <v-col cols="12" sm="4">
                        <v-menu v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y
                          min-width="auto">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="date" label="Fecha" prepend-inner-icon="mdi-calendar" readonly
                              v-bind="attrs" v-on="on" outlined dense hide-details class="white--text"></v-text-field>
                          </template>
                          <v-date-picker v-model="date" :min="dates_accounting.start_date"
                            :max="dates_accounting.end_date" @input="menu2 = false"></v-date-picker>
                        </v-menu>
                      </v-col>

                      <v-btn class="mr-3" icon @click="print_trial">
                        <v-icon color="white">print</v-icon>
                      </v-btn>

                      <v-btn @click="save" class="px-6 py-2">
                        <v-icon left>mdi-content-save</v-icon>
                        Guardar
                      </v-btn>
                    </v-app-bar>

                    <v-container fluid class="mt-n1 bg-grey-lighten-4">
                      <v-card class="rounded-lg" elevation="2">
                        <v-card-title class="py-3 px-6 rounded-t">
                          <v-icon left>mdi-format-list-bulleted</v-icon>
                          <span class="text-h6 font-weight-medium">Detalles de la entrada
                            {{ newEntryDairy[0]?.diary_book_id }}
                          </span>
                          <v-spacer></v-spacer>
                          <v-btn color="primary" depressed @click="addLine" class="px-4 text-none rounded-lg"
                            style="border: 1px solid rgba(255, 255, 255, 0.5)">
                            <v-icon left small>mdi-plus</v-icon>
                            <span class="text-capitalize">Agregar línea</span>
                          </v-btn>
                        </v-card-title>

                        <v-data-table :headers="headers" :items="newEntryDairy" class="elevation-0" :header-props="{
                          class: 'primary white--text',
                          'sort-icon': 'mdi-arrow-up',
                          'hide-default-header': false,
                        }" :item-class="'hover-row'" :footer-props="{
                            'items-per-page-options': [10, 20, 30, -1],
                            'items-per-page-text': 'Filas por página:',
                          }" show-expand :single-expand="true" :expanded.sync="expanded" item-key="id"
                          :loading="loading" :items-per-page="10" dense>
                          <template v-slot:[`item.cuentaContable`]="{ item }">
                            <v-autocomplete v-model="item.cuentaContable" :items="accounts" @change="
                              item.categoryDgii = item.cuentaContable.dgii_category_id;
                              resetInvalidAccountCategory(item, categories, item.cuentaContable, 'diary_book_category_id', 'diary_book_sub_category_id')
                              " label="Cuenta contable" outlined dense hide-details></v-autocomplete>
                          </template>

                          <template v-slot:[`item.location_id`]="{ item }">
                            <v-autocomplete v-model="item.location_id" :items="itemsLocations2" label="Location"
                              outlined dense hide-details prepend-inner-icon="mdi-map-marker"></v-autocomplete>
                          </template>

                          <template v-slot:[`item.currency_id`]="{ item }">
                            <v-autocomplete v-model="item.currency_id" :items="currencies" label="Moneda" outlined dense
                              hide-details @change="onCurrencyChange(item)"></v-autocomplete>
                          </template>

                          <template v-slot:[`item.exchange_rate`]="{ item }">
                            <v-tooltip bottom :disabled="!item.exchange_rate || item.exchange_rate == 1">
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="item.exchange_rate" label="Tasa" type="number" min="0"
                                  step="0.01" outlined dense hide-details class="text-right" v-bind="attrs" v-on="on"
                                  :background-color="item.exchange_rate && item.exchange_rate != 1 ? 'blue-grey lighten-5' : ''"></v-text-field>
                              </template>
                              <span v-if="item.exchange_rate && item.exchange_rate != 1">
                                1 {{ baseCurrencyCode }} = {{ item.exchange_rate ? (1 /
                                  parseFloat(item.exchange_rate)).toFixed(2) : '?' }} {{
                                  typeof item.currency_id === 'object' ? item.currency_id.text : '' }}
                              </span>
                            </v-tooltip>
                          </template>

                          <template v-slot:[`item.debito`]="{ item }">
                            <v-text-field v-model="item.debito" :disabled="item.credito !== ''" label="Débito"
                              type="number" min="0" outlined dense hide-details
                              @input="calculateDOP(item)"></v-text-field>
                          </template>

                          <template v-slot:[`item.credito`]="{ item }">
                            <v-text-field v-model="item.credito" :disabled="item.debito !== ''" label="Crédito"
                              type="number" min="0" outlined dense hide-details
                              @input="calculateDOP(item)"></v-text-field>
                          </template>

                          <template v-slot:[`item.debito_dop`]="{ item }">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-chip small v-bind="attrs" v-on="on"
                                  :color="item.location_id && balanceStatus.locations[item.location_id] ? (balanceStatus.locations[item.location_id].balanced ? 'green' : 'red lighten-1') : 'grey'"
                                  text-color="white">
                                  {{ item.debito_dop ? currencyFormat(parseFloat(item.debito_dop)) : '0.00' }}
                                </v-chip>
                              </template>
                              <span>{{ item.debito_dop ? parseFloat(item.debito_dop).toFixed(2) : '0.00' }} {{
                                baseCurrencyCode }}</span>
                            </v-tooltip>
                          </template>

                          <template v-slot:[`item.credito_dop`]="{ item }">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-chip small v-bind="attrs" v-on="on"
                                  :color="item.location_id && balanceStatus.locations[item.location_id] ? (balanceStatus.locations[item.location_id].balanced ? 'green' : 'red lighten-1') : 'grey'"
                                  text-color="white">
                                  {{ item.credito_dop ? currencyFormat(parseFloat(item.credito_dop)) : '0.00' }}
                                </v-chip>
                              </template>
                              <span>{{ item.credito_dop ? parseFloat(item.credito_dop).toFixed(2) : '0.00' }} {{
                                baseCurrencyCode }}</span>
                            </v-tooltip>
                          </template>

                          <template v-slot:[`item.actions`]="{ item }">
                            <v-btn icon small @click="deleteItem(item)" color="error">
                              <v-icon small>mdi-delete</v-icon>
                            </v-btn>
                          </template>

                          <!-- SECCIÓN MEJORADA DEL EXPANDIDO -->
                          <template v-slot:expanded-item="{ headers, item }">
                            <td :colspan="headers.length" class="pa-0">
                              <v-card flat class="ma-4 elevation-3 rounded-lg">
                                <!-- Header mejorado para la sección expandida -->
                                <v-card-title class="py-3 px-4 blue-grey lighten-5">
                                  <v-icon left color="primary">mdi-information-outline</v-icon>
                                  <span class="text-h6 primary--text">Información Adicional</span>
                                  <v-spacer></v-spacer>
                                  <v-chip small color="primary" outlined>
                                    ID: {{ item.id }}
                                  </v-chip>
                                </v-card-title>

                                <v-divider></v-divider>

                                <!-- Contenido organizado en secciones -->
                                <v-card-text class="pa-6">
                                  <!-- Sección Principal -->
                                  <div class="mb-1 mt-n5">
                                    <v-subheader class="px-0 text-subtitle-1 font-weight-bold primary--text">
                                      <v-icon left color="primary" small>mdi-pencil</v-icon>
                                      Información Principal
                                    </v-subheader>
                                    <v-row>
                                      <v-col cols="12" md="6">
                                        <v-text-field v-model="item.descripcion" label="Descripción" outlined dense
                                          hide-details prepend-inner-icon="mdi-text"></v-text-field>
                                      </v-col>
                                      <v-col cols="12" md="6">
                                        <v-autocomplete v-model="item.categoryDgii" :items="categoryDgii"
                                          label="Categoría DGII" outlined dense hide-details
                                          prepend-inner-icon="mdi-tag"></v-autocomplete>
                                      </v-col>
                                    </v-row>
                                  </div>

                                  <v-divider class="my-4"></v-divider>

                                  <!-- Sección de Clasificación -->
                                  <div class="mb-6 mt-n4">
                                    <v-subheader class="px-0 text-subtitle-1 font-weight-bold success--text">
                                      <v-icon left color="success" small>mdi-folder-multiple</v-icon>
                                      Clasificación y Organización
                                    </v-subheader>
                                    <v-row>
                                      <v-col cols="12" md="4">
                                        <v-autocomplete v-model="item.entity_id" :items="entity"
                                          :search-input.sync="entity_name" label="Entidad" outlined dense hide-details
                                          prepend-inner-icon="mdi-account-group" @keydown="getEntitys">
                                          <template v-slot:no-data>
                                            <div class="pa-2 text-center grey--text">
                                              <v-icon>mdi-magnify</v-icon>
                                              <br />
                                              Digita la entidad
                                            </div>
                                          </template>
                                        </v-autocomplete>
                                      </v-col>
                                      <v-col cols="12" md="4">
                                        <v-autocomplete v-model="item.department_id" :items="itemsDepartment"
                                          label="Departamento" outlined dense hide-details
                                          prepend-inner-icon="mdi-domain">

                                        </v-autocomplete>
                                      </v-col>
                                      <v-col cols="12" md="4">
                                        <v-autocomplete v-model="item.diary_book_category_id"
                                          :items="categoriesForAccount(categories, item.cuentaContable)"
                                          @change="item.diary_book_sub_category_id = null"
                                          label="Categoría" item-text="name" item-value="id" outlined dense
                                          hide-details
                                          prepend-inner-icon="mdi-format-list-bulleted-type"></v-autocomplete>
                                      </v-col>
                                    </v-row>

                                    <v-row class="mt-2">
                                      <v-col cols="12" md="6">
                                        <v-autocomplete v-model="item.diary_book_sub_category_id"
                                          :items="subcategoriesForAccount(categories, item.cuentaContable, item.diary_book_category_id)"
                                          label="Sub-Categoría" item-text="name" item-value="id" outlined dense
                                          hide-details
                                          prepend-inner-icon="mdi-subdirectory-arrow-right"></v-autocomplete>
                                      </v-col>
                                    </v-row>
                                  </div>

                                  <!-- Botones de acción en la sección expandida -->
                                  <v-card-actions class="px-0 pt-4">
                                    <v-spacer></v-spacer>
                                    <v-btn color="grey" text small @click="expanded = []">
                                      <v-icon left small>mdi-chevron-up</v-icon>
                                      Contraer
                                    </v-btn>
                                    <v-btn color="primary" small class="ml-2">
                                      <v-icon left small>mdi-check</v-icon>
                                      Aplicar
                                    </v-btn>
                                  </v-card-actions>
                                </v-card-text>
                              </v-card>
                            </td>
                          </template>
                        </v-data-table>
                      </v-card>

                      <v-row class="mt-6">
                        <v-col cols="12" md="6">
                          <v-card class="rounded-lg elevation-2">
                            <v-card-title class="py-3 px-4 orange lighten-4">
                              <v-icon left color="orange darken-2">mdi-note-text</v-icon>
                              <span class="text-subtitle-1 orange--text text--darken-2">
                                Observaciones
                              </span>
                            </v-card-title>
                            <v-card-text class="pa-4">
                              <v-textarea v-model="note" rows="3" outlined hide-details
                                placeholder="Ingrese observaciones adicionales..."></v-textarea>
                            </v-card-text>
                          </v-card>
                        </v-col>

                        <v-col cols="12" md="6">
                          <v-card class="rounded-lg elevation-2">
                            <v-card-title class="py-2 px-4"
                              :class="balanceStatus.isBalanced ? 'green lighten-4' : 'red lighten-4'">
                              <v-icon left :color="balanceStatus.isBalanced ? 'green darken-2' : 'red darken-2'">
                                {{ balanceStatus.isBalanced ? 'mdi-check-circle' : 'mdi-alert-circle' }}
                              </v-icon>
                              <span class="text-subtitle-1 font-weight-medium"
                                :class="balanceStatus.isBalanced ? 'green--text text--darken-2' : 'red--text text--darken-2'">
                                {{ balanceStatus.isBalanced ? 'Asiento Cuadrado' : 'Asiento Descuadrado' }}
                              </span>
                            </v-card-title>
                            <v-card-text class="pa-4">
                              <!-- Barra de progreso de balance -->
                              <div class="mb-3">
                                <div class="d-flex justify-space-between mb-1">
                                  <span class="caption grey--text">Balance</span>
                                  <span class="caption font-weight-bold"
                                    :class="balanceStatus.isBalanced ? 'green--text' : 'red--text'">
                                    {{ balanceStatus.percentage.toFixed(0) }}%
                                  </span>
                                </div>
                                <v-progress-linear :value="balanceStatus.percentage"
                                  :color="balanceStatus.isBalanced ? 'green' : 'red lighten-1'" height="6" rounded
                                  background-color="grey lighten-3"></v-progress-linear>
                              </div>

                              <!-- Totales por moneda -->
                              <v-row>
                                <v-col cols="6">
                                  <div class="text-center">
                                    <v-icon color="red" size="18">mdi-arrow-up</v-icon>
                                    <h3 class="caption font-weight-bold mb-2 red--text">Débito</h3>
                                    <div v-for="(value, key) in NewDebitoAndCredito" :key="key" class="mb-1">
                                      <v-chip v-if="value.debito" x-small
                                        :color="value.is_total ? (balanceStatus.isBalanced ? 'green darken-1' : 'red darken-1') : 'red lighten-1'"
                                        text-color="white" class="font-weight-bold">
                                        {{ value.debito }}
                                      </v-chip>
                                    </div>
                                  </div>
                                </v-col>
                                <v-col cols="6">
                                  <div class="text-center">
                                    <v-icon color="green" size="18">mdi-arrow-down</v-icon>
                                    <h3 class="caption font-weight-bold mb-2 green--text">Crédito</h3>
                                    <div v-for="(value, key) in NewDebitoAndCredito" :key="key" class="mb-1">
                                      <v-chip v-if="value.credito" x-small
                                        :color="value.is_total ? (balanceStatus.isBalanced ? 'green darken-1' : 'red darken-1') : 'green lighten-1'"
                                        text-color="white" class="font-weight-bold">
                                        {{ value.credito }}
                                      </v-chip>
                                    </div>
                                  </div>
                                </v-col>
                              </v-row>

                              <!-- Estado por location -->
                              <v-divider class="my-3"></v-divider>
                              <div v-for="(loc, locId) in balanceStatus.locations" :key="locId"
                                class="d-flex align-center mb-1">
                                <v-icon x-small :color="loc.balanced ? 'green' : 'red'" class="mr-1">
                                  {{ loc.balanced ? 'mdi-check-circle' : 'mdi-close-circle' }}
                                </v-icon>
                                <span class="caption">{{ loc.name }}</span>
                                <v-spacer></v-spacer>
                                <span v-if="!loc.balanced" class="caption red--text font-weight-bold">
                                  Dif: {{ loc.difference.toFixed(2) }} {{ baseCurrencyCode }}
                                </span>
                                <span v-else class="caption green--text font-weight-bold">OK</span>
                              </div>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-dialog>
                <v-badge color="red" overlap dot :value="user_group.length > 0">
                  <v-btn icon class="pb-2" @click="dialog_settings = true"><v-icon>filter_alt</v-icon></v-btn>
                </v-badge>
              </v-toolbar>
            </template>

            <!-- Resto de los templates del data-table principal -->
            <template v-slot:[`item.diary_book_code`]="{ item }">
              <div class="py-1">
                <v-hover v-slot="{ hover }">
                  <span @click="showItem(item)" class="font-weight-bold text-body-2" :style="{
                    color: hover ? '#1565C0' : '#1976D2',
                    cursor: 'pointer',
                    'text-decoration': hover ? 'underline' : 'none',
                  }">
                    {{ item.diary_book_code }}
                  </span>
                </v-hover>
                <div class="text-caption grey--text mt-n1">{{ item.formatted_date }}</div>
              </div>
            </template>

            <template v-slot:[`item.entity_name`]="{ item }">
              <template v-for="entity of item.entities">
                <v-hover v-slot="{ hover }" :key="entity.entity_id">
                  <span @click="viewEntity(entity.entity_id)" class="text-body-2 font-weight-medium" :style="{
                    color: hover ? '#1565C0' : '#1976D2',
                    cursor: 'pointer',
                    'text-decoration': hover ? 'underline' : 'none',
                  }">{{ entity.entity_name }}</span>
                </v-hover>
              </template>
            </template>

            <template v-slot:[`item.accounts`]="{ item }">
              <div class="py-1">
                <div v-for="(items, i) of item.diary_book_details" :key="i" class="text-caption">
                  <span class="font-weight-bold grey--text text--darken-2">{{ items.chart_of_account_code }}</span>
                  <span class="grey--text text--darken-1"> {{ items.chart_of_account_name }}</span>
                </div>
              </div>
            </template>

            <template v-slot:[`item.debito`]="{ item }">
              <div class="py-1">
                <div v-for="(items, i) of item.diary_book_details" :key="i">
                  <template v-if="items.entry_type_id == 1">
                    <span class="font-weight-bold success--text text-body-2">
                      {{ items.amount.toLocaleString("en-US", { style: "currency", currency: "USD" }) }}
                    </span>
                    <span class="text-caption grey--text ml-1">{{ items.currency_code }}</span>
                  </template>
                  <template v-else><span class="text-caption grey--text text--lighten-1">—</span></template>
                </div>
              </div>
            </template>

            <template v-slot:[`item.credito`]="{ item }">
              <div class="py-1">
                <div v-for="(items, i) of item.diary_book_details" :key="i">
                  <template v-if="items.entry_type_id == 2">
                    <span class="font-weight-bold error--text text-body-2">
                      {{ items.amount.toLocaleString("en-US", { style: "currency", currency: "USD" }) }}
                    </span>
                    <span class="text-caption grey--text ml-1">{{ items.currency_code }}</span>
                  </template>
                  <template v-else><span class="text-caption grey--text text--lighten-1">—</span></template>
                </div>
              </div>
            </template>

            <template v-slot:[`item.user`]="{ item }">
              <span class="text-caption grey--text text--darken-2">{{ item.user_fullname }}</span>
            </template>

            <template slot="body.append">
              <template v-if="Array.isArray(debitoAndCredito)">
                <tr v-for="(total, index) in debitoAndCredito" :key="'currency-' + index"
                  style="background: #f5f5f5; border-top: 2px solid #e0e0e0;">
                  <td colspan="4"></td>
                  <td class="font-weight-black text-body-2 py-2" style="color: #455A64;">
                    TOTAL {{ total.currency }}
                  </td>
                  <td class="font-weight-black text-body-2 text-right py-2 success--text">
                    {{ currencyFormat(total.debito) }} {{ total.currency }}
                  </td>
                  <td class="font-weight-black text-body-2 text-right py-2 error--text">
                    {{ currencyFormat(total.credito) }} {{ total.currency }}
                  </td>
                  <td colspan="2"></td>
                </tr>
              </template>
              <template v-else>
                <tr style="background: #f5f5f5; border-top: 2px solid #e0e0e0;">
                  <td colspan="4"></td>
                  <td class="font-weight-black text-body-2 py-2" style="color: #455A64;">TOTAL</td>
                  <td class="font-weight-black text-body-2 text-right py-2 success--text">
                    {{ currencyFormat(debitoAndCredito.debito) }}
                  </td>
                  <td class="font-weight-black text-body-2 text-right py-2 error--text">
                    {{ currencyFormat(debitoAndCredito.credito) }}
                  </td>
                  <td colspan="2"></td>
                </tr>
              </template>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-menu offset-y left>
                <template v-slot:activator="{ attrs, on }">
                  <v-btn icon small v-bind="attrs" v-on="on">
                    <v-icon small>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list dense class="py-0">
                  <v-list-item @click="editItem(item, 3)" dense>
                    <v-list-item-icon class="mr-2"><v-icon small color="warning">mdi-pencil</v-icon></v-list-item-icon>
                    <v-list-item-title class="text-body-2">Editar</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="editItem(item, 2)" dense>
                    <v-list-item-icon class="mr-2"><v-icon small
                        color="primary">mdi-content-copy</v-icon></v-list-item-icon>
                    <v-list-item-title class="text-body-2">Copiar</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="editItem(item, 1)" dense>
                    <v-list-item-icon class="mr-2"><v-icon small
                        color="blue">mdi-swap-horizontal</v-icon></v-list-item-icon>
                    <v-list-item-title class="text-body-2">Invertir</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="downloadSingleEntryPDF(item)"
                    :disabled="!item.diary_book_details || item.diary_book_details.length === 0" dense>
                    <v-list-item-icon class="mr-2"><v-icon small color="red">mdi-file-pdf-box</v-icon></v-list-item-icon>
                    <v-list-item-title class="text-body-2">Imprimir</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>

          </v-data-table>

          <v-skeleton-loader v-else v-bind="attrs"
            type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"
            height="500px"></v-skeleton-loader>
        </v-card>
      </v-col>
    </v-row>

    <!-- Resto de los diálogos -->
    <v-dialog v-model="dialogView" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable>
      <v-card>
        <ViewEntryDiary :entryDiary="selectedItem" @close="dialogView = false" :key="selectedItem.diary_book_id">
        </ViewEntryDiary>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogError" width="600px" persistent>
      <v-card>
        <v-card-title class="error white--text">
          <v-icon left color="white">error_outline</v-icon>
          Asiento Descuadrado
        </v-card-title>
        <v-card-text class="pt-4">
          <v-alert v-for="(error, index) in errorsMessage" :key="index" color="blue-grey lighten-5" border="left"
            colored-border elevation="1" class="mb-3">
            <pre
              style="white-space: pre-wrap; font-family: 'Roboto', sans-serif; font-size: 14px; line-height: 1.6; color: #37474F;">
          {{ error }}</pre>
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialogError = false">
            <v-icon left>check</v-icon>
            Entendido
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_settings" width="30%">
      <v-card>
        <v-card-title>Otros filtros</v-card-title>
        <v-card-text>
          <v-row justify="center">
            <span style="font-size: 15px; color: #616161">Agrupar por usuarios</span>
          </v-row>
          <v-row align="center" justify="center">
            <v-col md="10">
              <v-autocomplete v-model="user_group" outlined multiple dense no-data-text="No hay facturas" hide-details
                :items="users" label="Usuarios"></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="success" @click="dialog_settings = false">Aceptar</v-btn>
          <v-btn text color="error" @click="(user_group = []), (dialog_settings = false)">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from "moment";
import ViewEntryDiary from "../../components/Accounting/ViewEntryDiary.vue";
import jsPDF from "jspdf";
import "jspdf-autotable";
import accountCategoryRules from "../../mixins/accountCategoryRules";

export default {
  mixins: [accountCategoryRules],
  data: () => ({
    attrs: {
      class: "mb-12 mt-12",
      boilerplate: true,
      elevation: 2,
    },
    dates_accounting: {
      start_date: "",
      end_date: "",
    },
    dialog_settings: false,
    user_group: [],
    expanded: [],
    loading: false,
    isEditing: false,
    dialogError: false,
    entity_name: "",
    entity_id: null,
    accounts: [],
    projects: [],
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    menu: false,
    menu2: false,
    selectedCategoryDgii: "",
    errorsMessage: [],
    categoryDgii: [],
    seletecName: "",
    dialogView: false,
    items: [],
    itemsBussines: [],
    itemsLocations: [],
    itemsLocations2: [],
    itemsDepartment: [],
    note: "",
    currency_id: "",
    selectedItem: [],
    entity: [],
    currencies: [],

    selectedCurrencies: "",
    customers: [],
    itemSaved: [],
    categoryDgii: [],
    newItem: [],
    dataDiary: [],
    itemsRoutes: [],
    editedItem: [],
    catalogue_id: null,
    editedIndex: -1,
    filters: { business: "", location: null, department_id: null, routes: "" },
    editedIndex: -1,
    categories: [],
    dialog: false,
    last_data: null,
    dialogDelete: false,
    all_currencies: [],
    exchange_rates: [],
    headers: [
      { text: "Cuenta contable", value: "cuentaContable" },
      { text: "Location", value: "location_id", width: "10%" },
      { text: "Moneda", value: "currency_id", align: "end", width: "8%" },
      { text: "Tasa", value: "exchange_rate", align: "end", width: "8%" },
      { text: "Débito", value: "debito", align: "end", width: "10%" },
      { text: "Crédito", value: "credito", align: "end", width: "10%" },
      { text: "Débito (Base)", value: "debito_dop", align: "end", width: "10%" },
      { text: "Crédito (Base)", value: "credito_dop", align: "end", width: "10%" },
      { text: "", value: "actions", width: "5%" },
      { text: "", value: "data-table-expand" },
    ],
    headersDataDiary: [
      {
        text: "Asiento",
        align: "start",
        sortable: false,
        value: "diary_book_code",
        width: "14%",
      },
      {
        text: "Unidad de negocio",
        value: "business_unit_description",
        width: "15%",
      },
      // { text: "Fecha", value: "created_date", width: "10%" },
      { text: "Entidad", value: "entity_name" },

      { text: "Cuenta contable", value: "accounts" },

      { text: "Debito", value: "debito", align: "end" },
      { text: "Credito", value: "credito", align: "end" },
      { text: "Acciones", value: "actions", align: "end" },
    ],
    newEntryDairy: [],
  }),

  created() {
    this.getData();
  },
  components: { ViewEntryDiary },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Nueva entrada de diario "
        : "Editar entrada de diario " + this.newEntryDairy.length > 0
          ? this.newEntryDairy[0].diary_book_code
          : "";
    },
    debitoAndCredito() {
      const totals = {};

      // Process all diary entries
      for (const item of this.dataDiary_filtered) {
        if (item.diary_book_details) {
          item.diary_book_details.forEach((detail) => {
            const currencyCode = detail.currency_code || "DOP"; // Default to DOP if no currency code

            // Initialize currency entry if it doesn't exist
            if (!totals[currencyCode]) {
              totals[currencyCode] = {
                currency: currencyCode,
                debito: 0,
                credito: 0,
              };
            }

            // Sum amounts by entry type
            if (detail.entry_type_id === 1) {
              totals[currencyCode].debito += parseFloat(detail.amount) || 0;
            } else if (detail.entry_type_id === 2) {
              totals[currencyCode].credito += parseFloat(detail.amount) || 0;
            }
          });
        }
      }

      // Convert to array and format numbers
      return Object.values(totals).map((currency) => ({
        ...currency,
        debito: parseFloat(currency.debito.toFixed(2)),
        credito: parseFloat(currency.credito.toFixed(2)),
      }));
    },
    balanceStatus() {
      // Verificar cuadre por location en tiempo real
      const locations = {};
      let totalDebitBase = 0;
      let totalCreditBase = 0;

      this.newEntryDairy.forEach((item) => {
        const locId = item.location_id;
        if (!locId) return;

        if (!locations[locId]) {
          const locName = this.itemsLocations2.find(l => l.value == locId)?.text || `Location ${locId}`;
          locations[locId] = { name: locName, debit: 0, credit: 0 };
        }

        if (item.debito && item.debito !== '') {
          const val = item.debito_dop ? parseFloat(item.debito_dop) : 0;
          locations[locId].debit += val;
          totalDebitBase += val;
        }
        if (item.credito && item.credito !== '') {
          const val = item.credito_dop ? parseFloat(item.credito_dop) : 0;
          locations[locId].credit += val;
          totalCreditBase += val;
        }
      });

      // Verificar cuadre por location
      const locationStatus = {};
      Object.entries(locations).forEach(([locId, data]) => {
        const d = Math.round(data.debit * 100) / 100;
        const c = Math.round(data.credit * 100) / 100;
        locationStatus[locId] = {
          name: data.name,
          debit: d,
          credit: c,
          balanced: d === c,
          difference: Math.abs(d - c)
        };
      });

      const totalD = Math.round(totalDebitBase * 100) / 100;
      const totalC = Math.round(totalCreditBase * 100) / 100;

      return {
        locations: locationStatus,
        totalDebit: totalD,
        totalCredit: totalC,
        isBalanced: totalD === totalC && totalD > 0,
        difference: Math.abs(totalD - totalC),
        percentage: totalD > 0 ? Math.min((Math.min(totalD, totalC) / Math.max(totalD, totalC)) * 100, 100) : 0
      };
    },
    baseCurrencyCode() {
      if (this.exchange_rates.length > 0) {
        const baseCurrency = this.all_currencies.find(
          curr => curr.id === this.exchange_rates[0].default_currency_id
        );
        if (baseCurrency) return baseCurrency.code;
      }
      return 'USD';
    },
    NewDebitoAndCredito() {
      const totals = {};
      let totalDebitoDOP = 0;
      let totalCreditoDOP = 0;

      // Agrupando y sumando débitos
      this.newEntryDairy.forEach((element) => {
        if (element.debito > 0) {
          const amount = parseFloat(element.debito);
          if (!totals[element.currency_id]) {
            totals[element.currency_id] = { debito: 0, credito: 0, code: "" };
          }
          totals[element.currency_id].debito += amount;

          // Sumar al total en DOP
          if (element.debito_dop) {
            totalDebitoDOP += parseFloat(element.debito_dop);
          }
        }
      });

      // Agrupando y sumando créditos
      this.newEntryDairy.forEach((element) => {
        if (element.credito > 0) {
          const amount = parseFloat(element.credito);
          if (!totals[element.currency_id]) {
            totals[element.currency_id] = { debito: 0, credito: 0, code: "" };
          }
          totals[element.currency_id].credito += amount;

          // Sumar al total en DOP
          if (element.credito_dop) {
            totalCreditoDOP += parseFloat(element.credito_dop);
          }
        }
      });

      // Concatenar información de all_currencies incluyendo el código de la moneda
      Object.keys(totals).forEach((currency_id) => {
        const currencyInfo = this.all_currencies.find(
          (currency) => currency.id == currency_id
        );
        if (currencyInfo) {
          totals[currency_id].currency_name = currencyInfo.name;
          totals[currency_id].currency_symbol = currencyInfo.symbol;
          totals[currency_id].code = currencyInfo.code;
        } else {
          totals[currency_id].currency_name = "Unknown";
          totals[currency_id].currency_symbol = "?";
          totals[currency_id].code = "N/A";
        }

        // Formatear los montos a dos decimales y preparar salida con código
        totals[currency_id].debito = `${totals[currency_id].debito.toFixed(2)} ${totals[currency_id].code}`;
        totals[currency_id].credito = `${totals[currency_id].credito.toFixed(2)} ${totals[currency_id].code}`;
      });

      // Obtener código de moneda base
      let baseCurrencyCode = 'USD'; // Default
      if (this.exchange_rates.length > 0) {
        const baseCurrency = this.all_currencies.find(
          curr => curr.id === this.exchange_rates[0].default_currency_id
        );
        if (baseCurrency) {
          baseCurrencyCode = baseCurrency.code;
        }
      }

      // Agregar total en moneda base
      totals['BASE_TOTAL'] = {
        debito: `${totalDebitoDOP.toFixed(2)} ${baseCurrencyCode}`,
        credito: `${totalCreditoDOP.toFixed(2)} ${baseCurrencyCode}`,
        code: baseCurrencyCode,
        currency_name: `Total en ${baseCurrencyCode}`,
        is_total: true
      };

      return totals;
    },
    users() {
      const uniqueUsers = this.dataDiary.reduce((acc, invoice) => {
        if (!acc.some((users) => users.value === invoice.user_fullname)) {
          acc.push({
            text: invoice.user_fullname,
            value: invoice.created_by,
          });
        }
        return acc;
      }, []);
      return uniqueUsers;
    },
    dataDiary_filtered() {
      let entrys = this.dataDiary;
      if (this.user_group.length > 0) {
        entrys = entrys.filter((invoice) => this.user_group.includes(invoice.created_by));
      }
      return entrys;
    },
  },
  watch: {
    "filters.business"(val) {
      this.dates_accounting.start_date = "";
      this.dates_accounting.end_date = "";
      if (val != 0) {
        this.getCalendar();
        // Cargar tasas de cambio cuando cambia la unidad de negocio
        if (this.dialog && this.date) {
          this.loadExchangeRates();
        }
      }
    },
    date(val) {
      // Recargar tasas cuando cambia la fecha
      if (this.dialog && this.filters.business && this.filters.business !== 0) {
        this.loadExchangeRates();
      }
    },
    // dialogDelete(val) {
    //   val || this.closeDelete();
    // },
  },
  methods: {
    async showDialogNew() {
      this.isEditing = false;
      this.editedIndex = -1;
      this.date = moment().format("YYYY-MM-DD");
      this.addLine();
      this.addLine();
      this.note = null;

      // Cargar tasas de cambio al abrir el diálogo
      if (this.filters.business && this.filters.business !== 0) {
        await this.loadExchangeRates();
      }
    },
    async getCalendar() {
      let request_calendar = {
        business_unit: this.filters.business,
        module: 1,
      };
      const request = await this.api_Post(
        "accounting/get_calendar_accounting",
        request_calendar
      );
      if (request.status == 200) {
        const data = await request.json();
        if (data.length > 0) {
          this.dates_accounting.start_date = moment(data[0].from_date).format(
            "YYYY-MM-DD"
          );
          this.dates_accounting.end_date = moment(data[0].to_date).format("YYYY-MM-DD");

          // Al editar conservamos la fecha de la entrada; solo se sobreescribe en entradas nuevas
          if (!this.isEditing) {
            this.date = moment(data[0].from_date).format("YYYY-MM-DD");
          }
        }
      }
    },
    getDate(date) {
      let newDate = moment(date).format("YYYY-MM-DD HH:MM:SS A").toString();
      return newDate;
    },
    loadCategory(item) {
      return item.dgii_category_id;
    },
    async searchLoaded(item) {

      this.loading = true;
      this.last_data = item;
      let filters = "AND DIARY_BOOK_TYPE_ID = 2  ";
      filters +=
        item.business != 0 ? "and business_unit_id in(" + item.business + ")" : "";
      //filters += item.location != 0 ? " and location_id in (" + item.location + ")" : "";
      filters +=
        item.dateStart != 0 ? " and effective_date>= " + `'${item.dateStart}'` : "";
      filters += item.dateEnd != 0 ? " and effective_date<= " + `'${item.dateEnd}'` : "";

      const responseRequest = await this.api_Post("accounting/diary_book", {
        filtros: filters,
      });
      let dataDiarys = await responseRequest.json();
      this.dataDiary = dataDiarys;
      this.loading = false;
    },
    async getEntitys() {
      this.entity = [];

      let typ = "";
      const responseRequest = await this.api_Post("accounting/search_entity", {
        name: this.entity_name,
        type: typ,
        all: false,
      });

      if (responseRequest.ok) {
        let data = await responseRequest.json();
        for (let item of data) {
          this.entity.push({ text: item.name, value: item.entity_id });
        }
      }
    },
    async getData() {
      //  this.loading = true;
      this.filters.location = this.$store.state.app.filters.location;
      const result = await Promise.all([
        this.api_Get("accounting/categories_diary_book"),
        this.api_Get("accounting/currencies"),
        this.api_Get("accounting/accountsUsable"),
        this.g_departments(),
        this.api_Get("accounting/category_dgii"),
      ]);

      this.itemsBussines = Object.assign([], this.$store.state.auth.bussines_units);

      this.itemsLocations = Object.assign([], this.$store.state.auth.locations);

      this.filters.business = this.$store.state.app.filters.business;
      this.itemsLocations2 = this.updateCombo(
        this.itemsLocations,
        this.itemsLocations2,
        this.filters.business,
        "location"
      );

      this.categories = await result[0].json();

      for (let item of await result[1].json()) {
        this.currencies.push({ text: item.description, value: item.id });
        this.all_currencies.push(item);
      }
      let accounts = await result[2].json();

      for (let item of accounts) {
        this.accounts.push({
          text: item.code + " - " + item.name,
          value: item.id,
          dgii_category_id: item.dgii_category_id,
        });
      }

      for (let item of await result[3]) {

        this.itemsDepartment.push({ text: item.value + " - " + item.text, value: item.value });
      }

      //this.itemsDepartment = await result[3];
      for (let item of await result[4].json()) {
        this.categoryDgii.push({ text: item.name, value: item.id });
      }

      //  this.loading = false;
    },
    showItem(item) {
      let route = this.$router.resolve({ name: "ViewEntryDetail", params: { id: item.diary_book_id }, });
      window.open(route.href);
      return
      this.dialogView = false;

      this.selectedItem = item;

      let data = [];
      for (let item of this.selectedItem.diary_book_details) {
        data.push({
          amount: item.amount,
          chart_of_account_code: item.chart_of_account_code,
          chart_of_account_id: item.chart_of_account_id,
          chart_of_account_name: item.chart_of_account_name,
          credito: item.entry_type_id == 1 ? "" : item.amount,
          debito: item.entry_type_id == 2 ? "" : item.amount,
          dgii_categorie_name: item.dgii_categorie_name,
          currency_id: item.currency_id,
          dgii_category_id: item.dgii_category_id,
          diary_book_code: item.diary_book_code,
          diary_book_id: item.diary_book_id,
          entry_type_id: item.entry_type_id,
          entry_type_name: item.entry_type_name,
          category_id: item.category_id,
          subcategory_id: item.subcategory_id,
          department_id: item.department_id,
          diary_book_project_id: item.diary_book_project_id,
          note: item.note,
        });
      }

      this.selectedItem.diary_book_details = data;
      this.dialogView = true;
    },
    addLine() {
      this.newEntryDairy.push({
        id: this.newEntryDairy.length + 1,
        cuentaContable: "",
        categoryDgii: "",
        descripcion: "",
        diary_book_sub_category_id: null,
        diary_book_category_id: null,
        location_id: null,
        currency_id: null,
        exchange_rate: 1,
        debito: "",
        credito: "",
        debito_dop: "",
        credito_dop: "",
      });
    },
    async save() {
      let json = [];
      if (this.filters.business == 0) {
        this.$toast.info("Debes elegir una unidad de negocio");
        return;
      }

      for (let item of this.newEntryDairy) {
        let type = 0;
        let amount = 0;

        if (item.debito == "") {
          type = 2;
          amount = parseFloat(item.credito);
        } else if (item.credito == "") {
          type = 1;
          amount = parseFloat(item.debito);
        }

        if (item.cuentaContable == "") {
          this.$toast.info("Debes elegir la cuentas contables");
          return;
        }
        const categoryError = this.accountCategoryError(
          this.categories,
          item.cuentaContable,
          item.diary_book_category_id,
          item.diary_book_sub_category_id,
          this.accounts.find((acc) => acc.value === item.cuentaContable)?.text || ""
        );
        if (categoryError) {
          this.$toast.info(categoryError);
          return;
        }
        if (
          item.diary_book_category_id &&
          !item.diary_book_sub_category_id &&
          this.subcategoriesForAccount(this.categories, item.cuentaContable, item.diary_book_category_id).length > 0
        ) {
          this.$toast.info("Debes elegir la subcategoría");
          return;
        }
        if (
          item.location_id == "" ||
          item.location_id == 0 ||
          item.location_id == null ||
          item.location_id == undefined
        ) {
          this.$toast.info("Debes elegir el location");
          return;
        }
        if (
          item.currency_id == "" ||
          item.currency_id == 0 ||
          item.currency_id == null ||
          item.currency_id == undefined
        ) {
          this.$toast.info("Debes elegir la moneda");
          return;
        }

        // Obtener el ID de la moneda
        const currencyId = typeof item.currency_id === 'object' ? item.currency_id.value : item.currency_id;

        // Obtener el ID de la entidad (el autocomplete entrega el value numérico,
        // pero puede venir como objeto; cualquier vacío se envía como null)
        const entityId =
          typeof item.entity_id === 'object' && item.entity_id !== null
            ? item.entity_id.value
            : item.entity_id;

        // categories.push({category_id:item.diary_book_category_id})
        // sub_categories.push({category_id:item.diary_book_sub_category_id})
        json.push({
          chart_of_account_id: item.cuentaContable,
          dgii_category_id: item.categoryDgii,
          department_id: item.department_id,
          currency_id: currencyId,
          currency_rate: item.exchange_rate || null, // Enviar la tasa de cambio
          diary_book_project_id: item.diary_book_project_id,
          category_id: item.diary_book_category_id,
          subcategory_id: item.diary_book_sub_category_id,
          location_id: item.location_id,
          entry_type_id: type,
          amount: amount, // ENVIAR MONTO ORIGINAL en la moneda seleccionada
          entity_id: entityId || null,
          note: item.descripcion,
        });
      }
      // Agrupar por location_id y calcular totales en DOP
      const groupedByLocation = {};

      this.newEntryDairy.forEach((item) => {
        const location_id = item.location_id;

        if (!groupedByLocation[location_id]) {
          groupedByLocation[location_id] = {
            debit_dop: 0,
            credit_dop: 0,
            location_name: '',
            lines: [] // Guardar detalle de líneas
          };
        }

        // Obtener nombre de cuenta
        const accountName = this.accounts.find(acc => acc.value === item.cuentaContable)?.text || 'Cuenta';
        const currencyCode = typeof item.currency_id === 'object' ? item.currency_id.text : 'N/A';

        // Sumar débitos y créditos en DOP
        if (item.debito && item.debito !== '') {
          const debitDOP = item.debito_dop ? parseFloat(item.debito_dop) : 0;
          groupedByLocation[location_id].debit_dop += debitDOP;
          groupedByLocation[location_id].lines.push({
            account: accountName,
            type: 'Débito',
            original: `${parseFloat(item.debito).toFixed(2)} ${currencyCode}`,
            converted: `${debitDOP.toFixed(2)}`,
            rate: item.exchange_rate
          });
        }

        if (item.credito && item.credito !== '') {
          const creditDOP = item.credito_dop ? parseFloat(item.credito_dop) : 0;
          groupedByLocation[location_id].credit_dop += creditDOP;
          groupedByLocation[location_id].lines.push({
            account: accountName,
            type: 'Crédito',
            original: `${parseFloat(item.credito).toFixed(2)} ${currencyCode}`,
            converted: `${creditDOP.toFixed(2)}`,
            rate: item.exchange_rate
          });
        }
      });

      // Obtener código de moneda base
      let baseCurrencyCode = 'USD'; // Default
      if (this.exchange_rates.length > 0) {
        const baseCurrency = this.all_currencies.find(
          curr => curr.id === this.exchange_rates[0].default_currency_id
        );
        if (baseCurrency) {
          baseCurrencyCode = baseCurrency.code;
        }
      }

      // Validar que cada location esté cuadrado en moneda base
      this.errorsMessage = [];
      Object.entries(groupedByLocation).forEach(([location_id, totals]) => {
        const locationName = this.itemsLocations2.find(
          (element) => element.value == location_id
        )?.text || `Location ${location_id}`;

        // Redondear a 2 decimales antes de comparar
        const debitRounded = Math.round(totals.debit_dop * 100) / 100;
        const creditRounded = Math.round(totals.credit_dop * 100) / 100;

        if (debitRounded !== creditRounded) {
          const difference = Math.abs(debitRounded - creditRounded);
          const needsMore = debitRounded > creditRounded ? 'crédito' : 'débito';

          // Construir mensaje detallado
          let errorMessage = `⚠️ ASIENTO DESCUADRADO - ${locationName}\n\n`;
          errorMessage += `📊 Resumen en ${baseCurrencyCode}:\n`;
          errorMessage += `   • Total Débitos:  ${debitRounded.toFixed(2)} ${baseCurrencyCode}\n`;
          errorMessage += `   • Total Créditos: ${creditRounded.toFixed(2)} ${baseCurrencyCode}\n`;
          errorMessage += `   • Diferencia:     ${difference.toFixed(2)} ${baseCurrencyCode}\n\n`;

          // Mostrar detalle de cada línea
          errorMessage += `📝 Detalle de líneas:\n`;
          totals.lines.forEach((line, idx) => {
            errorMessage += `   ${idx + 1}. ${line.account}\n`;
            errorMessage += `      ${line.type}: ${line.original} → ${line.converted} ${baseCurrencyCode}\n`;
            errorMessage += `      (Tasa: ${line.rate ? parseFloat(line.rate).toFixed(6) : 'N/A'})\n`;
          });

          errorMessage += `\n💡 Solución: Falta ${difference.toFixed(2)} ${baseCurrencyCode} en ${needsMore}\n`;
          errorMessage += `   Verifica que los montos originales sean correctos.\n`;
          errorMessage += `   Ejemplo: Si la tasa es 0.015748, entonces 6350 DOP = 100 ${baseCurrencyCode}`;

          this.errorsMessage.push(errorMessage);
        }
      });
      if (this.errorsMessage.length > 0) {
        this.dialogError = true;
        return;
      }

      const responseRequest = await this.api_Post("accounting/diary_entry", {
        diary_book_id:
          this.newEntryDairy[0].diary_book_id == undefined
            ? null
            : this.newEntryDairy[0].diary_book_id,
        user_id: this.$store.state.auth.user.user.user_id,
        effective_date: this.date,
        bussiness_units: this.filters.business,

        location: this.filters.location == 0 ? null : this.filters.location,

        note: this.note,
        // currency_id: this.currency_id.value,

        details: json,
      });
      if (responseRequest.status == 200) {
        this.searchLoaded(this.last_data);
        this.closeDialog();
        this.$toast.success("entrada agregada con exito!");
      } else {
        this.$toast.error("error al agregar la cuenta!");
      }
    },
    closeDialog() {
      this.dialog = false;
      this.isEditing = false;
      this.newEntryDairy = [];
    },
    async onCurrencyChange(item) {
      // Obtener el ID de la moneda (puede ser objeto o número)
      const currencyId = typeof item.currency_id === 'object' ? item.currency_id.value : item.currency_id;



      // Validar que haya unidad de negocio y fecha
      if (!this.filters.business || this.filters.business === 0) {
        this.$toast.warning("Debes seleccionar una unidad de negocio para obtener la tasa de cambio");
        item.exchange_rate = 1;
        return;
      }

      if (!this.date) {
        this.$toast.warning("Debes seleccionar una fecha para obtener la tasa de cambio");
        item.exchange_rate = 1;
        return;
      }

      // Obtener tasa de cambio
      await this.getExchangeRate(item);
    },
    async loadExchangeRates() {
      try {
        const response = await this.api_Post("accounting/currenciesBusiness", {
          business: this.filters.business,
          effective_date: this.date
        });

        if (response.status === 200) {
          this.exchange_rates = await response.json();


          // Actualizar tasas en todas las líneas existentes
          this.newEntryDairy.forEach(item => {
            if (item.currency_id) {
              const currencyId = typeof item.currency_id === 'object' ? item.currency_id.value : item.currency_id;
              // Solo actualizar si no es null/undefined
              if (currencyId) {
                this.getExchangeRate(item);
              }
            }
          });
        } else {
          this.$toast.error("Error al cargar tasas de cambio");
          this.exchange_rates = [];
        }
      } catch (error) {
        console.error("Error al cargar tasas de cambio:", error);
        this.$toast.error("Error al cargar tasas de cambio");
        this.exchange_rates = [];
      }
    },
    async getExchangeRate(item) {
      // Si no hay tasas cargadas, cargarlas primero
      if (this.exchange_rates.length === 0) {
        await this.loadExchangeRates();
      }

      // Obtener el ID de la moneda (puede ser objeto o número)
      const currencyId = typeof item.currency_id === 'object' ? item.currency_id.value : item.currency_id;

      // Buscar la tasa para la moneda seleccionada
      const currencyRate = this.exchange_rates.find(
        (curr) => curr.foreing_currency_id === currencyId
      );



      if (currencyRate && currencyRate.value) {
        const rateValue = parseFloat(currencyRate.value);
        const baseCurrencyId = currencyRate.default_currency_id;

        // LÓGICA DE CONVERSIÓN A MONEDA BASE:
        // La tasa del API siempre es: 1 unidad de moneda base = X unidades de moneda extranjera
        // Ejemplo: 1 USD = 63.5 DOP, 1 USD = 8.8284 EUR, 1 USD = 133 HTG

        // Si la moneda seleccionada ES la moneda base
        if (currencyId === baseCurrencyId) {
          // No hay conversión necesaria
          item.exchange_rate = 1;
        }
        // Si NO es la moneda base
        else {
          // Para convertir DE moneda extranjera A moneda base: DIVIDIR
          // Ejemplo: 6350 DOP / 63.5 = 100 USD
          // Ejemplo: 88.284 EUR / 8.8284 = 10 USD
          item.exchange_rate = 1 / rateValue;
        }



        this.calculateDOP(item);
      } else {
        this.$toast.warning(`No se encontró tasa de cambio para esta moneda en la fecha ${this.date}`);
        item.exchange_rate = 1;
      }
    },
    calculateDOP(item) {
      // Si no hay tasa de cambio, usar 1
      const rate = parseFloat(item.exchange_rate) || 1;


      // Calcular débito en DOP
      if (item.debito && item.debito !== '') {
        const debitoAmount = parseFloat(item.debito);
        item.debito_dop = (debitoAmount * rate).toFixed(2);
        item.credito_dop = '';

      }
      // Calcular crédito en DOP
      else if (item.credito && item.credito !== '') {
        const creditoAmount = parseFloat(item.credito);
        item.credito_dop = (creditoAmount * rate).toFixed(2);
        item.debito_dop = '';

      }
      // Limpiar si no hay montos
      else {
        item.debito_dop = '';
        item.credito_dop = '';
      }
    },
    updateCombo(itemsOrigen, itemsDestino, condicion, combo) {
      itemsDestino.splice(0, itemsDestino.length);

      for (let item of itemsOrigen) {
        if (item.bus_id === condicion) {
          itemsDestino.push({
            value: item.value,
            text: item.text,
            routes: item.routes,
          });
        }
      }

      if (this.itemsLocations2.length > 0) {
        this.filters.location = this.itemsLocations2[0].value;
      }

      return itemsDestino;
    },
    deleteItem(item) {
      this.editedIndex = this.newEntryDairy.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.newEntryDairy.splice(this.editedIndex, 1);
    },

    editItem(item, type) {
      this.isEditing = true;
      this.selectedCategoryDgii = this.editedItem.dgii_category_id;
      this.editedIndex = 0;
      this.editedItem = Object.assign({}, item);
      this.date = this.editedItem.effective_date_text;

      // Posicionar la unidad de negocio de la entrada para que el combo de
      // locations (itemsLocations2) contenga las sucursales correctas; de lo
      // contrario el location de cada línea queda en blanco al no existir en la lista.
      this.filters.business = this.editedItem.business_unit_id;
      this.itemsLocations2 = this.updateCombo(
        this.itemsLocations,
        this.itemsLocations2,
        this.filters.business,
        "location"
      );
      this.filters.location = this.editedItem.location_id;

      // Precargar las entidades de la entrada para que el autocomplete muestre
      // el nombre (la lista solo se llena al buscar, por eso quedaba en blanco).
      this.entity = (this.editedItem.entities || []).map((e) => ({
        text: e.entity_name,
        value: e.entity_id,
      }));

      this.newEntryDairy = [];

      for (let detail of this.editedItem.diary_book_details) {
        let newType = null;
        if (type == 1) {
          detail.diary_book_id = undefined;
          if (detail.entry_type_id === 1) {
            newType = 2;
          } else if (detail.entry_type_id === 2) {
            newType = 1;
          }
        } else if (type == 2 || type == 3) {
          newType = detail.entry_type_id;
        }
        if (type == 2) {
          detail.diary_book_id = undefined;
        }

        // Recuperar la tasa de cambio usada al guardar (almacenada en amounts)
        // para precargar la tasa y poder recalcular los montos en moneda base.
        let exchange_rate = 1;
        if (this.editedItem.amounts && Array.isArray(this.editedItem.amounts)) {
          const amountInfo = this.editedItem.amounts.find(
            (a) => a.currency_id === detail.currency_id
          );
          if (amountInfo && amountInfo.currency_rate) {
            exchange_rate = parseFloat(amountInfo.currency_rate);
          }
        }

        this.newEntryDairy.push({
          diary_book_id: detail.diary_book_id == undefined ? null : detail.diary_book_id,
          diary_book_code: detail.diary_book_code,
          id: this.newEntryDairy.length + 1,
          amount: detail.amount,
          chart_of_account_code: detail.chart_of_account_code,
          cuentaContable: detail.chart_of_account_id,
          chart_of_account_id: detail.chart_of_account_id,
          chart_of_account_name: detail.chart_of_account_name,
          credito: newType == 1 ? "" : detail.amount,
          debito: newType == 2 ? "" : detail.amount,
          currency_id: detail.currency_id,
          exchange_rate: exchange_rate,
          debito_dop: "",
          credito_dop: "",
          dgii_categorie_name: detail.dgii_categorie_name,
          categoryDgii: detail.dgii_category_id,
          category_id: detail.category_id,
          location_id: detail.location_id,
          subcategory_id: detail.subcategory_id,
          // El template usa diary_book_category_id / diary_book_sub_category_id
          diary_book_category_id: detail.category_id,
          diary_book_sub_category_id: detail.subcategory_id,
          entry_type_id: newType,
          entry_type_name: detail.entry_type_name,
          department_id: detail.department_id,
          entity_id: detail.entity_id,
          diary_book_project_id: detail.diary_book_project_id,
          note: detail.note,
        });
      }

      // Calcular los montos en moneda base de cada línea con la tasa recuperada.
      this.newEntryDairy.forEach((line) => this.calculateDOP(line));

      if (type == 3) {
        this.editedIndex === -1;
      }
      this.seletecName = this.editedItem.name;
      this.note = item.note;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    addAccount(item) {
      this.editedItem = [];
      this.itemSaved = [];
      this.selectedCategoryDgii = "";
      this.editedIndex = -1;
      let data = Object.assign({}, item);
      this.itemSaved = data;
      this.seletecName = data.name;
      this.editedItem.name = "";
      this.editedItem.code = "";
      this.dialog = true;
    },
    flattenTree(data) {
      const result = [];

      data.forEach(entry => {
        if (entry.diary_book_details && entry.diary_book_details.length > 0) {
          entry.diary_book_details.forEach(detail => {
            // Construir categorías y subcategorías
            let categoryInfo = '';
            if (detail.category_name && detail.subcategory_name) {
              categoryInfo = `${detail.category_name} / ${detail.subcategory_name}`;
            } else if (detail.category_name) {
              categoryInfo = detail.category_name;
            } else if (detail.subcategory_name) {
              categoryInfo = detail.subcategory_name;
            }

            // Construir información de departamentos
            let departmentInfo = '';
            if (detail.departments && detail.departments.length > 0) {
              departmentInfo = detail.departments.map(dept => dept.name).join(', ');
            }

            result.push({
              diary_book_code: entry.diary_book_code,
              created_date: entry.created_date,
              effective_date: entry.effective_date,
              note: entry.note,
              user_fullname: entry.user_fullname,
              entity_name: entry.entity_name,
              business_unit_description: entry.business_unit_description,
              business_unit_description_long: entry.business_unit_description_long,
              location_description_long: detail.location_description_long,
              chart_of_account_code: detail.chart_of_account_code,
              chart_of_account_name: detail.chart_of_account_name,
              currency_code: detail.currency_code,
              amount: detail.amount,
              entry_type_id: detail.entry_type_id,
              debito: detail.entry_type_id === 1 ? detail.amount : 0,
              credito: detail.entry_type_id === 2 ? detail.amount : 0,
              // Campos de transacción según el tipo de entrada del detalle
              amount_debit: detail.entry_type_id === 1 ? detail.amount : 0,
              amount_credit: detail.entry_type_id === 2 ? detail.amount : 0,
              debit_currency_code: detail.entry_type_id === 1 ? detail.currency_code : entry.business_unit_currency_code,
              credit_currency_code: detail.entry_type_id === 2 ? detail.currency_code : entry.business_unit_currency_code,
              // Calcular valores base usando currency_rate del array amounts
              base_debit: detail.entry_type_id === 1 ? this.calculateBaseAmount(detail, entry) : 0,
              base_credit: detail.entry_type_id === 2 ? this.calculateBaseAmount(detail, entry) : 0,
              business_unit_currency_code: entry.business_unit_currency_code || 'DOP',
              category_info: categoryInfo,
              department_info: departmentInfo
            });
          });
        }
      });

      return result;
    },
    calculateBaseAmount(detail, entry) {
      // Buscar el currency_rate en el array amounts del entry
      if (entry.amounts && Array.isArray(entry.amounts)) {
        const amountInfo = entry.amounts.find(amount =>
          amount.currency_id === detail.currency_id &&
          amount.entry_type_id === detail.entry_type_id
        );

        if (amountInfo && amountInfo.currency_rate) {
          return detail.amount * parseFloat(amountInfo.currency_rate);
        }
      }

      // Fallback: si no hay currency_rate, usar el amount original
      return detail.amount;
    },
    generatePDFContent(flattenedData) {
      const doc = new jsPDF({
        orientation: 'landscape',
        unit: 'mm',
        format: 'a4'
      });

      // Configuración de fuentes
      doc.setFont('helvetica');

      // Header superior con información de la empresa
      const firstEntry = flattenedData.length > 0 ? flattenedData[0] : {};

      let currentY = 10;

      // Título: business_unit_description_long
      doc.setFontSize(14);
      doc.setFont('helvetica', 'bold');
      const businessTitle = firstEntry.business_unit_description_long || firstEntry.business_unit_description || '';
      doc.text(businessTitle, 148, currentY, { align: 'center' });
      currentY += 6;

      // Subtítulo: location_description_long
      if (firstEntry.location_description_long) {
        doc.setFontSize(10);
        doc.setFont('helvetica', 'normal');
        doc.text(firstEntry.location_description_long, 148, currentY, { align: 'center' });
        currentY += 5;
      }

      // "Detalle del Asiento"
      doc.setFontSize(10);
      doc.setFont('helvetica', 'bold');
      doc.text('Detalle del Asiento', 148, currentY, { align: 'center' });
      currentY += 4;

      // Línea decorativa
      doc.setLineWidth(0.5);
      doc.line(20, currentY, 277, currentY);

      // Información del header en formato de tabla
      let headerY = currentY + 5;
      if (flattenedData.length > 0) {

        // Crear tabla de información del header
        const headerData = [];

        if (firstEntry.diary_book_code) {
          headerData.push(['No Asiento:', firstEntry.diary_book_code]);
        }
        if (firstEntry.created_date) {
          headerData.push(['Fecha:', moment(firstEntry.created_date).format('DD/MM/YYYY')]);
        }
        if (firstEntry.effective_date) {
          headerData.push(['Fecha Contable:', moment(firstEntry.effective_date).format('DD/MM/YYYY')]);
        }
        if (firstEntry.user_fullname) {
          headerData.push(['Creado por:', firstEntry.user_fullname]);
        }

        // Tabla de header
        if (headerData.length > 0) {
          doc.autoTable({
            body: headerData,
            startY: headerY,
            theme: 'plain',
            styles: {
              fontSize: 9,
              cellPadding: 2
            },
            columnStyles: {
              0: { cellWidth: 40, fontStyle: 'bold', halign: 'left' },
              1: { cellWidth: 60, halign: 'left' }
            },
            margin: { left: 20 }
          });
          headerY = doc.lastAutoTable.finalY + 5;
        }

        // Descripción/Nota
        if (firstEntry.note) {
          doc.setFontSize(9);
          doc.setFont('helvetica', 'bold');
          doc.text('Descripción:', 20, headerY);
          doc.setFont('helvetica', 'normal');
          const noteLines = doc.splitTextToSize(firstEntry.note, 250);
          doc.text(noteLines, 20, headerY + 4);
          headerY += (noteLines.length * 4) + 8;
        }
      }

      // Línea separadora antes de la tabla
      doc.setLineWidth(0.3);
      doc.line(20, headerY, 277, headerY);
      headerY += 5;

      // Preparar datos para la tabla con las nuevas columnas
      const tableData = flattenedData.map(item => [
        item.chart_of_account_code || '',
        item.chart_of_account_name || '',
        item.category_info || '',
        item.department_info || '',
        item.amount_debit ? `${parseFloat(item.amount_debit).toLocaleString('es-DO', { minimumFractionDigits: 2 })} ${item.debit_currency_code || 'DOP'}` : '',
        item.amount_credit ? `${parseFloat(item.amount_credit).toLocaleString('es-DO', { minimumFractionDigits: 2 })} ${item.credit_currency_code || 'DOP'}` : '',
        item.base_debit ? `${parseFloat(item.base_debit).toLocaleString('es-DO', { minimumFractionDigits: 2 })} ${item.business_unit_currency_code || 'DOP'}` : '',
        item.base_credit ? `${parseFloat(item.base_credit).toLocaleString('es-DO', { minimumFractionDigits: 2 })} ${item.business_unit_currency_code || 'DOP'}` : ''
      ]);

      // Configuración de la tabla con diseño más estético
      const tableConfig = {
        head: [[
          'Cód. Cuenta',
          'Descripción',
          'Categoría/Subcategoría',
          'Departamento',
          'Débito Transacción',
          'Crédito Transacción',
          'Débito Base',
          'Crédito Base'
        ]],
        body: tableData,
        startY: headerY,
        theme: 'striped',
        headStyles: {
          fillColor: [52, 73, 94],
          textColor: 255,
          fontStyle: 'bold',
          fontSize: 9,
          halign: 'center',
          cellPadding: 3
        },
        bodyStyles: {
          fontSize: 8,
          cellPadding: 2.5,
          lineColor: [189, 195, 199],
          lineWidth: 0.1
        },
        columnStyles: {
          0: { cellWidth: 20, halign: 'center', fontStyle: 'bold' }, // Cód. Cuenta
          1: { cellWidth: 50, halign: 'left' },   // Descripción
          2: { cellWidth: 35, halign: 'left' },   // Categoría/Subcategoría
          3: { cellWidth: 30, halign: 'left' },   // Departamento
          4: { cellWidth: 35, halign: 'right', fontStyle: 'bold' },  // Débito Transacción
          5: { cellWidth: 35, halign: 'right', fontStyle: 'bold' },  // Crédito Transacción
          6: { cellWidth: 35, halign: 'right', fontStyle: 'bold' },  // Débito Base
          7: { cellWidth: 35, halign: 'right', fontStyle: 'bold' }   // Crédito Base
        },
        alternateRowStyles: {
          fillColor: [248, 249, 250]
        },
        margin: { left: 15, right: 15 }
      };

      // Generar la tabla
      doc.autoTable(tableConfig);

      // Calcular totales por moneda para transacción y base
      const totalsTransaccion = {};
      const totalesBase = { debito: 0, credito: 0 };

      flattenedData.forEach(item => {
        // Para débitos
        if (item.amount_debit && parseFloat(item.amount_debit) > 0) {
          const debitCurrency = item.debit_currency_code || 'DOP';
          if (!totalsTransaccion[debitCurrency]) {
            totalsTransaccion[debitCurrency] = { debito: 0, credito: 0 };
          }
          totalsTransaccion[debitCurrency].debito += parseFloat(item.amount_debit) || 0;
        }

        // Para créditos
        if (item.amount_credit && parseFloat(item.amount_credit) > 0) {
          const creditCurrency = item.credit_currency_code || 'DOP';
          if (!totalsTransaccion[creditCurrency]) {
            totalsTransaccion[creditCurrency] = { debito: 0, credito: 0 };
          }
          totalsTransaccion[creditCurrency].credito += parseFloat(item.amount_credit) || 0;
        }

        // Totales base en moneda de la unidad de negocio
        totalesBase.debito += parseFloat(item.base_debit) || 0;
        totalesBase.credito += parseFloat(item.base_credit) || 0;
      });

      // Línea separadora antes de totales
      let finalY = doc.lastAutoTable.finalY + 8;
      doc.setLineWidth(0.3);
      doc.line(20, finalY, 277, finalY);
      finalY += 8;

      // Crear tabla de totales con diseño profesional
      const totalsData = [];

      // Totales de transacción por moneda
      Object.keys(totalsTransaccion).forEach(currency => {
        const total = totalsTransaccion[currency];
        totalsData.push([
          `Total Transacción ${currency}:`,
          total.debito.toLocaleString('es-DO', { minimumFractionDigits: 2 }),
          total.credito.toLocaleString('es-DO', { minimumFractionDigits: 2 }),
          '', ''
        ]);
      });

      // Total base en moneda de la unidad de negocio
      const baseCurrency = flattenedData.length > 0 ? (flattenedData[0].business_unit_currency_code || 'DOP') : 'DOP';
      totalsData.push([
        `Total Base ${baseCurrency}:`,
        '', '',
        totalesBase.debito.toLocaleString('es-DO', { minimumFractionDigits: 2 }),
        totalesBase.credito.toLocaleString('es-DO', { minimumFractionDigits: 2 })
      ]);

      // Tabla de totales
      doc.autoTable({
        head: [['', 'Débito Transacción', 'Crédito Transacción', 'Débito Base', 'Crédito Base']],
        body: totalsData,
        startY: finalY,
        theme: 'grid',
        headStyles: {
          fillColor: [52, 73, 94],
          textColor: 255,
          fontStyle: 'bold',
          fontSize: 9,
          halign: 'center'
        },
        bodyStyles: {
          fontSize: 9,
          fontStyle: 'bold',
          cellPadding: 3
        },
        columnStyles: {
          0: { cellWidth: 50, halign: 'left' },
          1: { cellWidth: 35, halign: 'right', fillColor: [230, 245, 255] },
          2: { cellWidth: 35, halign: 'right', fillColor: [255, 245, 230] },
          3: { cellWidth: 35, halign: 'right', fillColor: [230, 255, 230] },
          4: { cellWidth: 35, halign: 'right', fillColor: [255, 230, 255] }
        },
        margin: { left: 15 }
      });

      // Información adicional en el pie
      const currentDate = moment().format('DD/MM/YYYY HH:mm');
      const totalLines = flattenedData.length;

      finalY = doc.lastAutoTable.finalY + 15;
      doc.setFontSize(8);
      doc.setFont('helvetica', 'normal');
      doc.text(`Total Líneas: ${totalLines}`, 20, finalY);
      doc.text(`Generado: ${currentDate}`, 200, finalY);

      // Pie de página profesional
      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);

        // Línea superior del pie
        doc.setLineWidth(0.2);
        doc.line(20, 195, 277, 195);

        // Información del pie
        doc.setFontSize(7);
        doc.setFont('helvetica', 'normal');
        doc.text(`Página ${i} de ${pageCount}`, 148, 200, { align: 'center' });
        doc.text('Fin del Informe', 148, 204, { align: 'center' });
      }

      return doc;
    },
    downloadPDF() {
      try {
        const flattenedData = this.flattenTree(this.dataDiary_filtered);
        if (flattenedData.length === 0) {
          this.$toast.warning('No hay datos para generar el PDF');
          return;
        }

        const doc = this.generatePDFContent(flattenedData);
        const fileName = `detalle_asientos_${moment().format('YYYY-MM-DD_HH-mm')}.pdf`;
        doc.save(fileName);

        this.$toast.success('PDF generado exitosamente');
      } catch (error) {
        console.error('Error generando PDF:', error);
        this.$toast.error('Error al generar el PDF');
      }
    },
    downloadSingleEntryPDF(item) {
      try {
        if (!item.diary_book_details || item.diary_book_details.length === 0) {
          this.$toast.warning('Esta entrada no tiene detalles para generar PDF');
          return;
        }

        const singleEntryData = [item];
        const flattenedData = this.flattenTree(singleEntryData);

        const doc = this.generatePDFContent(flattenedData);
        const fileName = `asiento_${item.diary_book_code || 'sin_codigo'}_${moment().format('YYYY-MM-DD_HH-mm')}.pdf`;
        doc.save(fileName);

        this.$toast.success(`PDF del asiento ${item.diary_book_code} generado exitosamente`);
      } catch (error) {
        console.error('Error generando PDF individual:', error);
        this.$toast.error('Error al generar el PDF del asiento');
      }
    },
    print_trial() {
      this.downloadPDF();
    },
    currencyFormat(value) {
      // Esta función es necesaria para el formato de moneda en la tabla
      if (!value) return "$0.00";
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(value);
    },
    // viewEntity(id) {
    //   // Implementación de la función viewEntity

    // }
  },
};
</script>

<style scoped>
/* Estilos para filas de la tabla */
.hover-row {
  transition: background-color 0.2s;
}

.hover-row:hover {
  background-color: #f5f9ff !important;
}

/* Estilo para filas alternas */
.v-data-table tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.02);
}

/* Mejora en los botones de acción */
.v-btn {
  text-transform: none;
  letter-spacing: normal;
  font-weight: 500;
}

/* Mejora en los encabezados de tabla */
.v-data-table-header {
  background-color: #f5f5f5;
}

.v-data-table-header th {
  font-weight: 600 !important;
  font-size: 0.875rem !important;
}

/* Mejora en el hover de las filas */
.v-data-table>.v-data-table__wrapper>table>tbody>tr:not(:last-child)>td,
.v-data-table>.v-data-table__wrapper>table>tbody>tr:not(:last-child)>th {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

/* Efecto sutil al pasar el mouse sobre botones */
.v-btn:not(.v-btn--disabled) {
  transition: all 0.2s ease;
}

.v-btn:not(.v-btn--disabled):hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Mejora en los inputs */
.v-input {
  margin-top: 8px;
  margin-bottom: 8px;
}

/* Estilo para el scroll de la tabla */
.v-data-table__wrapper::-webkit-scrollbar {
  height: 8px;
  width: 8px;
}

.v-data-table__wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.v-data-table__wrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.dialog-card {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.v-data-table ::v-deep .v-data-table__wrapper {
  overflow-y: auto;
  max-height: calc(100vh - 400px);
}

/* Estilos adicionales para mejorar la apariencia */
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.8;
  position: absolute;
  width: 100%;
}

.expanded-content {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.section-header {
  border-left: 4px solid #1976d2;
  padding-left: 12px;
  margin-bottom: 16px;
}

.info-chip {
  margin: 2px;
}
</style>
